import { CookieManager } from './cookie-manager';
import { queryClient } from './query-client';

export async function logoutUser() {
  await queryClient.removeQueries();
  CookieManager.removeAuthTokens();
}
